<it-carousel type="three-cols-arrow-visible" lined="true" *ngIf="requestToComplete?.length">
    <it-carousel-item *ngFor="let request of requestToComplete">
      <div class="card-wrapper">
        <it-card>
          <div class="category-top">
            <a class="category" [routerLink]="'/detail/'+ request.uuid">{{request.code}}</a>
            <span class="data">{{request.insertDateTime | date: 'dd/MM/yyyy'}}</span>
          </div>
          <h6 class="card-title big-heading">{{request.patient.name}} {{request.patient.surname}}</h6>
          <h6 class="card-title big-heading">{{request.patient.fiscalCode}}</h6>
          <p class="card-text">
            {{request.setting.name}} 
          </p>
          <p class="card-text">
            {{request.setting.subSettings[0].name}}
          </p>
          <span class="card-signature"> {{request.insertUser.name}} {{request.insertUser.surname}}</span>
          <a class="read-more" [routerLink]="'/detail/'+ request.uuid">
            <span class="text"
              >Vai al dettaglio
            </span>
            <it-icon name="arrow-right"></it-icon>
          </a>
        </it-card>
      </div>
    </it-carousel-item>
</it-carousel>

<p *ngIf="!requestToComplete?.length">Nessuna pratica da completare</p>
